import { Map, List, fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import moment from 'moment'
import ActionHelper from 'helpers/action'

// constants
export const FETCH_SITE_LIST = 'logbookForm/FETCH_SITE_LIST'
export const SUCCESS_SITE_LIST = 'logbookForm/SUCCESS_SITE_LIST'
export const FAILURE_SITE_LIST = 'logbookForm/FAILURE_SITE_LIST'
export const SET_SITE_LIST_LOADER = 'logbookForm/SET_SITE_LIST_LOADER'

export const FETCH_FORM_LIST = 'logbookForm/FETCH_FORM_LIST'
export const SUCCESS_FORM_LIST = 'logbookForm/SUCCESS_FORM_LIST'
export const FAILURE_FORM_LIST = 'logbookForm/FAILURE_FORM_LIST'
export const SET_FORM_LIST_LOADER = 'logbookForm/SET_FORM_LIST_LOADER'
export const SET_FORM_EVENT_VALUE_LOADER =
  'logbookForm/SET_FORM_EVENT_VALUE_LOADER'
export const SET_ACTIVE_FORM = 'logbookForm/SET_ACTIVE_FORM'

export const FETCH_LOCUS_GROUP_LIST = 'logbookForm/FETCH_LOCUS_GROUP_LIST'
export const SUCCESS_LOCUS_GROUP_LIST = 'logbookForm/SUCCESS_LOCUS_GROUP_LIST'
export const FAILURE_LOCUS_GROUP_LIST = 'logbookForm/FAILURE_LOCUS_GROUP_LIST'
export const SET_LOCUS_GROUP_LIST_LOADER =
  'logbookForm/SET_LOCUS_GROUP_LIST_LOADER'
export const SET_LOCUS_GROUP_EVENT_VALUE_LOADER =
  'logbookForm/SET_LOCUS_GROUP_EVENT_VALUE_LOADER'
export const SET_ACTIVE_LOCUS_GROUP = 'logbookForm/SET_ACTIVE_LOCUS_GROUP'

export const FETCH_LOCUS_LIST = 'logbookForm/FETCH_LOCUS_LIST'
export const SUCCESS_LOCUS_LIST = 'logbookForm/SUCCESS_LOCUS_LIST'
export const FAILURE_LOCUS_LIST = 'logbookForm/FAILURE_LOCUS_LIST'
export const SET_LOCUS_LIST_LOADER = 'logbookForm/SET_LOCUS_LIST_LOADER'
export const SET_LOCUS_EVENT_VALUE_LOADER =
  'logbookForm/SET_LOCUS_EVENT_VALUE_LOADER'
export const SET_ACTIVE_LOCUS = 'logbookForm/SET_ACTIVE_LOCUS'

export const FETCH_FORM_LEVEL_EVENT_VALUES =
  'logbookForm/FETCH_FORM_LEVEL_EVENT_VALUES'
export const SUCCESS_FORM_LEVEL_EVENT_VALUES =
  'logbookForm/SUCCESS_FORM_LEVEL_EVENT_VALUES'
export const FAILURE_FORM_LEVEL_EVENT_VALUES =
  'logbookForm/FAILURE_FORM_LEVEL_EVENT_VALUES'

export const FETCH_LOCUS_GROUP_LEVEL_EVENT_VALUES =
  'logbookForm/FETCH_LOCUS_GROUP_LEVEL_EVENT_VALUES'
export const SUCCESS_LOCUS_GROUP_LEVEL_EVENT_VALUES =
  'logbookForm/SUCCESS_LOCUS_GROUP_LEVEL_EVENT_VALUES'
export const FAILURE_LOCUS_GROUP_LEVEL_EVENT_VALUES =
  'logbookForm/FAILURE_LOCUS_GROUP_LEVEL_EVENT_VALUES'

export const FETCH_LOCUS_LEVEL_EVENT_VALUES =
  'logbookForm/FETCH_LOCUS_LEVEL_EVENT_VALUES'
export const SUCCESS_LOCUS_LEVEL_EVENT_VALUES =
  'logbookForm/SUCCESS_LOCUS_LEVEL_EVENT_VALUES'
export const FAILURE_LOCUS_LEVEL_EVENT_VALUES =
  'logbookForm/FAILURE_LOCUS_LEVEL_EVENT_VALUES'

export const FETCH_FORM_EVENT_LIST_WITH_DATA =
  'logbookForm/FETCH_FORM_EVENT_LIST_WITH_DATA'
export const SUCCESS_FORM_EVENT_LIST_WITH_DATA =
  'logbookForm/SUCCESS_FORM_EVENT_LIST_WITH_DATA'
export const FAILURE_FORM_EVENT_LIST_WITH_DATA =
  'logbookForm/FAILURE_FORM_EVENT_LIST_WITH_DATA'
export const SET_FORM_EVENT_LIST_WITH_DATA_LOADER =
  'logbookForm/SET_FORM_EVENT_LIST_WITH_DATA_LOADER'

export const SET_ACTIVE_DATE = 'logbookForm/SET_ACTIVE_DATE'

export const SAVE_EVENT_FORM = 'logbookForm/SAVE_EVENT_FORM'

export const CLEAR_STORE = 'logbookForm/CLEAR_STORE'

// actions
export const fetchSiteList = ActionHelper.createActionObj(FETCH_SITE_LIST)
export const fetchFormList = ActionHelper.createActionObj(FETCH_FORM_LIST)
export const fetchLocusGroupList = ActionHelper.createActionObj(
  FETCH_LOCUS_GROUP_LIST,
)
export const fetchLocusList = ActionHelper.createActionObj(FETCH_LOCUS_LIST)
export const fetchFormEventListWithData = ActionHelper.createActionObj(
  FETCH_FORM_EVENT_LIST_WITH_DATA,
)

export const fetchFormLevelEventValues = ActionHelper.createActionObj(
  FETCH_FORM_LEVEL_EVENT_VALUES,
)
export const fetchLocusGroupLevelEventValues = ActionHelper.createActionObj(
  FETCH_LOCUS_GROUP_LEVEL_EVENT_VALUES,
)
export const fetchLocusLevelEventValues = ActionHelper.createActionObj(
  FETCH_LOCUS_LEVEL_EVENT_VALUES,
)

export const setActiveDate = ActionHelper.createActionObj(SET_ACTIVE_DATE)
export const setActiveForm = ActionHelper.createActionObj(SET_ACTIVE_FORM)
export const setActiveLocusGroup = ActionHelper.createActionObj(
  SET_ACTIVE_LOCUS_GROUP,
)
export const setActiveLocus = ActionHelper.createActionObj(SET_ACTIVE_LOCUS)
export const saveEventForm = ActionHelper.createActionObj(SAVE_EVENT_FORM)
export const clearStore = ActionHelper.createActionObj(CLEAR_STORE)

// store
const initialState = fromJS({
  isLoadSiteList: false,
  isLoadFormList: false,
  isLoadLocusGroupList: false,
  isLoadLocusList: false,
  isLoadEventList: false,
  isLoadFormEventValues: false,
  isLoadLocusGroupEventValues: false,
  isLoadLocusEventValues: false,
  siteList: [],
  formList: [],
  locusGroupList: [],
  locusList: [],
  formEventList: [],
  formEventValues: [],
  locusGroupEventValues: [],
  locusEventValues: [],
  activeDate: moment(),
  activeForm: null,
  activeLocusGroup: null,
  activeLocus: null,
})

const logbookForm = handleActions(
  {
    [SUCCESS_SITE_LIST]: (state, action) =>
      state.set('siteList', List(action.payload)),
    [FAILURE_SITE_LIST]: state => state.set('siteList', List([])),
    [SET_SITE_LIST_LOADER]: (state, action) =>
      state.set('isLoadSiteList', Boolean(action.payload)),

    [SUCCESS_FORM_LIST]: (state, action) =>
      state.set('formList', List(action.payload)),
    [FAILURE_FORM_LIST]: state => state.set('formList', List([])),
    [SET_FORM_LIST_LOADER]: (state, action) =>
      state.set('isLoadFormList', Boolean(action.payload)),
    [SET_FORM_EVENT_VALUE_LOADER]: (state, action) =>
      state.set('isLoadFormEventValues', Boolean(action.payload)),
    [SET_ACTIVE_FORM]: (state, action) =>
      state.set('activeForm', Map(action.payload)),

    [SUCCESS_LOCUS_GROUP_LIST]: (state, action) =>
      state.set('locusGroupList', List(action.payload)),
    [FAILURE_LOCUS_GROUP_LIST]: state => state.set('locusGroupList', List([])),
    [SET_LOCUS_GROUP_LIST_LOADER]: (state, action) =>
      state.set('isLoadLocusGroupList', Boolean(action.payload)),
    [SET_LOCUS_GROUP_EVENT_VALUE_LOADER]: (state, action) =>
      state.set('isLoadLocusGroupEventValues', Boolean(action.payload)),
    [SET_ACTIVE_LOCUS_GROUP]: (state, action) =>
      state.set('activeLocusGroup', Map(action.payload)),

    [SUCCESS_LOCUS_LIST]: (state, action) =>
      state.set('locusList', List(action.payload)),
    [FAILURE_LOCUS_LIST]: state => state.set('locusList', List([])),
    [SET_LOCUS_LIST_LOADER]: (state, action) =>
      state.set('isLoadLocusList', Boolean(action.payload)),
    [SET_LOCUS_EVENT_VALUE_LOADER]: (state, action) =>
      state.set('isLoadLocusEventValues', Boolean(action.payload)),
    [SET_ACTIVE_LOCUS]: (state, action) =>
      state.set('activeLocus', Map(action.payload)),

    [SUCCESS_FORM_EVENT_LIST_WITH_DATA]: (state, action) =>
      state.set('formEventList', List(action.payload)),
    [FAILURE_FORM_EVENT_LIST_WITH_DATA]: state =>
      state.set('formEventList', List([])),
    [SET_FORM_EVENT_LIST_WITH_DATA_LOADER]: (state, action) =>
      state.set('isLoadEventList', Boolean(action.payload)),

    [SUCCESS_FORM_LEVEL_EVENT_VALUES]: (state, action) =>
      state.set('formEventValues', List(action.payload)),
    [FAILURE_FORM_LEVEL_EVENT_VALUES]: state =>
      state.set('formEventValues', List([])),

    [SUCCESS_LOCUS_GROUP_LEVEL_EVENT_VALUES]: (state, action) =>
      state.set('locusGroupEventValues', List(action.payload)),
    [FAILURE_LOCUS_GROUP_LEVEL_EVENT_VALUES]: state =>
      state.set('locusGroupEventValues', List([])),

    [SUCCESS_LOCUS_LEVEL_EVENT_VALUES]: (state, action) =>
      state.set('locusEventValues', List(action.payload)),
    [FAILURE_LOCUS_LEVEL_EVENT_VALUES]: state =>
      state.set('locusEventValues', List([])),

    [SET_ACTIVE_DATE]: (state, action) =>
      state.set('activeDate', action.payload),
  },
  initialState,
)

export default logbookForm
